import React, { Component } from 'react';
import { Link } from "react-router-dom";
import {
    Row,
    Col,
    Card,
    Icon,
    Table,
    Button,
    Select,
    message,
    DatePicker,
    Modal,
    Checkbox
} from 'antd';
import moment from 'moment';
import F from '../../Functions';
import axios from 'axios';
import { Translate } from 'react-translated';
import { TYPE_OF_CALL } from '../../utils/Constants';

const Option = Select.Option;
const { confirm } = Modal;

class RSUpload extends Component {
    state = {
        loading: false,
        agency_id: null,
        ready: false,
        date: null,
        agencies: [],
        bfiles: [],
        bfiles_copy: [],
        ids: [],
        selected_upload_type: []
    }
    componentDidMount = () => {
        axios.get("/api/rs_all_agencies").then((res) => {
            this.setState({
                agencies: res.data
            })
        })
    }
    search = () => {
        this.loadBFiles();
    }
    loadBFiles = () => {
        const { agency_id, date } = this.state;
        this.setState({
            loading: true,
            ready: true,
            selected_upload_type: []
        });
        axios.post("/api/get_rs_bfiles_list", {
            agency_id,
            date: moment(new Date(date)).format("YYYY-MM-DD")
        }).then((res) => {
            this.setState({
                loading: false,
                bfiles: res.data.bfiles,
                bfiles_copy: res.data.bfiles
            });
        });
    }
    deleteAll = () => {
        this.setState({ loading: true });
        if (this.state.ids.length > 0) {
            axios.post("/api/delete_rs_bfiles_ids", { ids: this.state.ids.join(",") }).then((res) => {
                this.setState({ loading: false, ids: [] });
                if (res.data.success) {
                    message.success(F.translate(`B files has been deleted successfully.`));
                    this.loadBFiles();
                } else {
                    message.error(F.translate(`Can't delete bfiles.`));
                }
            });
        } else {
            message.error(F.translate(`Please select at least one bfile.`));
        }
    }


    showConfirm(that) {
        confirm({
            title: "Are you sure you want to delete the selected data ?",
            okButtonProps: {
                className: 'borderRadius-28 btn-bg-164897',
            },
            cancelButtonProps: {
                className: 'borderRadius-28',
            },
            onOk() {
                return that.deleteAll()
            },
            onCancel() { },
        });
    }


handleChange(val) {
    this.setState({ selected_upload_type: val });

    let temp = [];

    if (!val || val.length === 0) {
        temp = this.state.bfiles;
    } else {
        temp = this.state.bfiles.filter(e => val.includes(e.type_of_call));
    }

    this.setState({ bfiles_copy: temp });
}


    // handleChange(val) {
    //     this.setState({ selected_upload_type: val })
    //     let temp = this.state.bfiles.length && this.state.bfiles.filter(e => !val.length ? true : val.includes(e.type_of_call)) || [];
    //     this.setState({ bfiles_copy: temp })
    // }

    render() {

        const { loading, bfiles, bfiles_copy, selected_upload_type } = this.state;

        const columns = [
            {
                title: 'Date',
                dataIndex: 'date',
                key: 'date'
            },
            {
                title: 'First Name',
                dataIndex: 'first_name',
                key: 'first_name'
            },
            {
                title: 'Last Name',
                dataIndex: 'last_name',
                key: 'last_name'
            },
            {
                title: 'Email',
                dataIndex: 'email',
                key: 'email'
            },
            {
                title: 'Phone',
                dataIndex: 'phone',
                key: 'phone'
            },
            {
                title: 'Upload Type',
                dataIndex: 'upload_type',
                key: 'upload_type'
            },
        ];
        for (var i = 0; i < columns.length; i++) {
            columns[i].title = (<Translate text={columns[i].title} />);
        }

        const data = [];
        for (let i = 0; i < bfiles_copy.length; i++) {
            let bfile = bfiles_copy[i];

            data.push({
                key: i,
                date: moment(new Date(bfile.created_on)).format("MM/DD/YYYY hh:mmA"),
                id: bfile.id,
                first_name: bfile.first_name || '-',
                last_name: bfile.last_name || '-',
                email: bfile.email || '-',
                phone: F.phone_format(bfile.phone) || '-',
                upload_type: TYPE_OF_CALL[`${bfile.type_of_call}`]
            })
        }

        const rowSelection = {
            onChange: (selectedRowKeys, selectedRows) => {
                var ids = [];
                for (let i = 0; i < selectedRows.length; i++) {
                    const item = selectedRows[i];
                    ids.push(item.id);
                }
                this.setState({
                    ids
                })
            },
            getCheckboxProps: (record) => ({
                name: record.name,
            }),
        };

        return (
            <div>
                <Card bordered={false} className="filters">
                    <Row gutter={16}>
                        <Col md={12} span={24}>
                            <Select value={this.state.agency_id} style={{ width: '100%', backgroundColor: "white" }} onChange={(value) => this.setState({ agency_id: value })}>
                                <Option value={null}>{"Select agency..."}</Option>
                                {this.state.agencies.map((agency) => (
                                    <Option key={agency.id} value={agency.id}>{agency.name}</Option>
                                ))}
                            </Select>
                        </Col>

                        <Col md={8} span={24}>
                            <DatePicker
                                value={this.state.date}
                                style={{ width: '100%', borderRadius: "20px" }}
                                onChange={(date) => this.setState({ date })}
                                format={"MM/DD/YYYY"}
                            />
                        </Col>
                        <Col md={4} span={24}>
                            <Button
                                className="borderRadius-28"
                                onClick={() => this.search()}>Search</Button>
                        </Col>
                    </Row>
                </Card>

                <Card
                    type="inner"
                    title={
                        <div style={{ paddingTop: 7 }}>
                            <Icon type="team" style={{ marginRight: 10, color: "#1890ff" }} />
                            <Translate text={`Edit Uploads`} />
                        </div>
                    }
                    className="tableCard"
                    loading={loading}
                    extra={

                        <div>
                            <Select
                                mode="multiple"
                                style={{ width: 220, wordBreak: '' }}
                                className='custom-select'
                                placeholder="Select Upload Type"
                                defaultValue={selected_upload_type}
                                value={selected_upload_type}
                                onChange={this.handleChange.bind(this)}
                                optionLabelProp="label"
                                maxTagCount={1}
                                suffixIcon={<span>...</span>}
                            >
                                <Option value="Review" label="Review">
                                    <Checkbox checked={selected_upload_type.includes('Review')}>Review</Checkbox>
                                </Option>
                                <Option value="Prospect" label="Lead">
                                    <Checkbox checked={selected_upload_type.includes('Prospect')}>Lead</Checkbox>
                                </Option>
                                <Option value="FollowUp" label="Opportunity">
                                    <Checkbox checked={selected_upload_type.includes('FollowUp')}>Opportunity</Checkbox>
                                </Option>
                            </Select>
                            &nbsp;
                            <Button type='danger'
                                style={{ marginLeft: '10px' }}
                                className="borderRadius-28"
                                disabled={!this.state.ids.length} onClick={() => this.showConfirm(this)}>
                                <Translate text={`Delete`} />
                            </Button>

                        </div>



                    }
                >
                    {this.state.agency_id && this.state.date && this.state.ready ? (
                        <Table
                            rowSelection={{
                                ...rowSelection,
                            }}
                            columns={columns}
                            dataSource={data}
                            bordered={false}
                            pagination={false}
                            locale={{ emptyText: "No Data To Show" }}
                        />
                    ) : (
                        <p style={{ padding: 22 }}>Select an agency and upload date</p>
                    )}
                </Card>
            </div>
        );

    }
}

export default RSUpload;



// WEBPACK FOOTER //
// ./src/scenes/SuperAdmin/edit-upload.js